import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { IMAGES } from "../../data/content";
import { SponsorGrid } from "./SponsorGrid";
import { Footer } from "./Footer";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${API_BASE}${u}` : u);
export const youtubeId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|v=|\/embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
};
export const instagramPath = (url = "") => {
  const m = url.match(/instagram\.com\/(reel|p|tv)\/([A-Za-z0-9_-]+)/);
  return m ? `${m[1]}/${m[2]}` : null;
};
/** Riconosce il tipo di link video incollato (YouTube o Instagram). */
export const detectVideoLink = (url) => (instagramPath(url) ? "instagram" : youtubeId(url) ? "youtube" : null);

/** Riproduttore unico: file video caricato oppure YouTube. */
export const VideoPlayer = ({ media, className = "" }) => {
  if (!media) return null;
  const ig = media.tipo === "instagram" ? instagramPath(media.url) : null;
  if (ig) {
    return (
      <div className={`flex justify-center bg-black ${className}`}>
        <iframe
          title={media.didascalia || "Reel Instagram"}
          src={`https://www.instagram.com/${ig}/embed/`}
          className="w-full max-w-[540px] h-[640px] sm:h-[760px] bg-white"
          allow="encrypted-media; clipboard-write"
          allowFullScreen
          data-testid="instagram-embed"
        />
      </div>
    );
  }
  const yt = media.tipo === "youtube" ? youtubeId(media.url) : null;
  if (yt) {
    return (
      <iframe
        title={media.didascalia || "Video"}
        src={`https://www.youtube-nocookie.com/embed/${yt}?rel=0`}
        className={`w-full aspect-video bg-black ${className}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    );
  }
  return <video src={mediaUrl(media.url)} controls playsInline className={`w-full aspect-video bg-black ${className}`} />;
};

/** Layout comune delle pagine interne: header, contenuto, sponsor, footer. */
export const PageShell = ({ eyebrow, title, subtitle, back = "/", children, testid = "inner-page" }) => (
  <div data-testid={testid} className="min-h-screen bg-neutral-950 text-neutral-100 flex flex-col">
    <header className="border-b border-neutral-800 bg-neutral-950/95 backdrop-blur sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3">
          <span className="w-3 h-3 bg-red-600 inline-block" />
          <img src={IMAGES.logoWhite} alt="Legend Team" className="h-6 w-auto" />
        </Link>
        <nav className="flex items-center gap-4 mono-label text-xs uppercase tracking-wider">
          <Link to="/gare" data-testid="nav-gare" className="text-neutral-300 hover:text-red-500">Gare</Link>
          <Link to="/interviste" data-testid="nav-interviste" className="text-neutral-300 hover:text-red-500">Interviste</Link>
          <Link to={back} className="hidden sm:inline-flex items-center gap-1 text-red-500 hover:text-red-400">
            <ArrowLeft className="w-3.5 h-3.5" /> Indietro
          </Link>
        </nav>
      </div>
    </header>
    <main className="flex-1">
      {title && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
          {eyebrow && <div className="mono-label text-xs text-red-500 uppercase tracking-wider mb-2">{eyebrow}</div>}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase text-white leading-none">{title}</h1>
          {subtitle && <p className="text-sm text-neutral-400 mt-3 max-w-3xl">{subtitle}</p>}
        </div>
      )}
      {children}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 border-t border-neutral-800 mt-16">
        <h2 className="font-display text-xl font-black uppercase text-white mb-4">I nostri sponsor</h2>
        <SponsorGrid />
      </section>
    </main>
    <Footer />
  </div>
);
